import { createPortal } from "react-dom"
import { useMap } from "react-leaflet"

// benchmap portalt children in eine beim Pannen transformierte Pane — HTML-UI muss deshalb zurück in den statischen Karten-Container
export default function MapUiSlot({ children }) {
  const map = useMap()
  return createPortal(children, map.getContainer())
}
